<template>
  <div class="code-box-demo">
    <a-slider :min="0"
              :max="1"
              :step="0.01"
              v-model="alphaValue" />
  </div>
</template>
<script>

import { debounce } from 'lodash'
let unwatch, parentMap
export default {
  name: 'MapAlpha',
  data () {
    return {
      disabled: false,
      alphaValue: 1.0
    }
  },
  mounted () {
    this.$nextTick(() => {
      parentMap = this.$parent.getBigMap()
      unwatch = this.$watch('alphaValue', this.changeAlpha)
    })
  },
  beforeDestroy () {
    if (unwatch) {
      unwatch()
      unwatch = null
    }
    parentMap = null
  },
  methods: {
    changeAlpha: debounce(function (value) {
      console.log(value)
      const allLayers = parentMap.getLayers().array_
      allLayers.forEach(item => {
        console.log(item)
        if (item.values_.name === '底图') {
          item.values_.opacity = value
          parentMap.render()
        }
      })
    }, 500)
  }
}
</script>
<style scoped>
.code-box-demo .ant-slider {
  margin-bottom: 16px;
}
</style>
